// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmedBooking_confirmationContainer__kM2M9 {
    height: 50vh;
}

.confirmedBooking_confirmationContainer__kM2M9 .confirmedBooking_confirmationSection__\\+cYGm {
    align-items: center;
    gap: 30px;
    padding-top: 30px;
}

.confirmedBooking_confirmationSection__\\+cYGm h1 {
    color: #495E57;
    text-align: center;
}

.confirmedBooking_confirmationSection__\\+cYGm svg {
    height: 100px;
    width: 100px;
}

.confirmedBooking_confirmationSection__\\+cYGm p {
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Reservations/ConfirmedBooking/confirmedBooking.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".confirmationContainer {\n    height: 50vh;\n}\n\n.confirmationContainer .confirmationSection {\n    align-items: center;\n    gap: 30px;\n    padding-top: 30px;\n}\n\n.confirmationSection h1 {\n    color: #495E57;\n    text-align: center;\n}\n\n.confirmationSection svg {\n    height: 100px;\n    width: 100px;\n}\n\n.confirmationSection p {\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationContainer": `confirmedBooking_confirmationContainer__kM2M9`,
	"confirmationSection": `confirmedBooking_confirmationSection__+cYGm`
};
export default ___CSS_LOADER_EXPORT___;
